export function cleanBlocksLayout(content) {
  const { blocks_layout, blocks } = content;

  // Filtra as chaves que existem em blocks
  const filteredBlocksLayout = blocks_layout?.items?.filter((key) => key in blocks);

  // Se após filtrar o blocks_layout ficar vazio, preenche com as chaves de blocks
  if (filteredBlocksLayout?.length === 0) {
    return { ...content, blocks_layout: { items: Object.keys(blocks) } };
  } else {
    return { ...content, blocks_layout: { items: filteredBlocksLayout } };
  }
}
